export default __webpack_public_path__ + "static/media/10607-dog-avatar-confused.d292a356.png";